import React from 'react';

import {GoogleMapView} from '../components/GoogleMapView';
import {OutlinePrimaryLink} from '../components/OutlinePrimaryLink';
import {PageMenu} from '../components/PageMenu';

export const CompanyPage: React.FC = () => (
  <main>
    <PageMenu active="/company" />

    <section className="pb-20 pt-16 text-center">
      <div className="mx-auto max-w-[840px] px-4">
        <h1 className="mb-9 mt-8 text-3xl font-light tracking-[2.1px] text-neutral-900">
          運営会社
        </h1>

        <dl className="mb-6 overflow-hidden text-left text-sm">
          <dt className="float-left clear-left w-1/5 font-bold text-neutral-900">
            会社名
          </dt>
          <dd className="ml-[25%] font-light text-neutral-900">
            株式会社エムセック
          </dd>
          <dt className="float-left clear-left w-1/5 font-bold text-neutral-900">
            設立
          </dt>
          <dd className="ml-[25%] font-light text-neutral-900">
            1985年12月14日
          </dd>
          <dt className="float-left clear-left w-1/5 font-bold text-neutral-900">
            本社所在地
          </dt>
          <dd className="ml-[25%] font-light text-neutral-900">〒723-0014</dd>
          <dd className="ml-[25%] font-light text-neutral-900">
            広島県三原市城町一丁目12-5{'　'}エムセックビル
          </dd>
        </dl>

        <div className="mb-6 h-[500px] w-full">
          <GoogleMapView />
        </div>

        <div className="mt-8 text-center">
          <OutlinePrimaryLink
            href="http://www.msec.co.jp/"
            size="md"
            target="_blank"
            rel="noreferrer">
            <span>詳しくはこちら</span>
            <i
              className="fas fa-external-link-alt ml-2 text-sm"
              aria-hidden="true"
            />
          </OutlinePrimaryLink>
        </div>
      </div>
    </section>
  </main>
);
